/*eslint-disable*/
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import { fetch, logout } from 'lib/network/webapi';
import * as actions from 'state/modules/assign';
import * as assigncreator from 'state/modules/topBar';
import * as util from 'lib/utility';
import { FixedTabs, Footer } from 'containers';
import _debug from 'debug';
import translate from 'i18n/translate';
import styles from './Assign.css';

const debug = _debug('app:assign');

export class Assign extends Component {
  static propTypes = {
    tabOneList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabTwoList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tabThreeList: PropTypes.arrayOf(PropTypes.shape({})),
    tabOneSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabTwoSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    tabThreeSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    leadsData: PropTypes.arrayOf(PropTypes.shape({})),
    rawLeadsData: PropTypes.arrayOf(PropTypes.shape({})),
    fetchAll: PropTypes.func,
    currentLanguage: PropTypes.string,
    updateUnassignedStartEndIndex: PropTypes.func,
    updateInspectedStartEndIndex: PropTypes.func,
    showLeads: PropTypes.func,
    showInspections: PropTypes.func,
    unassignedStartIndex: PropTypes.number,
    unassignedEndIndex: PropTypes.number,
    // setProgressbarLabel: PropTypes.func,
    updateAssignedStartEndIndex: PropTypes.func,
    assignedStartIndex: PropTypes.number,
    assignedEndIndex: PropTypes.number,
    activeIndex: PropTypes.number,
    updateActiveIndex: PropTypes.func,
    updateSelectedRecords: PropTypes.func,
    selectedRecords: PropTypes.arrayOf(PropTypes.shape({})),
    updateFilterExpanded: PropTypes.func,
    updateInspectionFilterExpanded: PropTypes.func,
    applyFilter: PropTypes.func,
    applyFilterIndex: PropTypes.func,
    reverseFilter: PropTypes.func,
    filterExpanded: PropTypes.bool,
    inspectionFilterExpanded: PropTypes.bool,
    filterValues: PropTypes.shape({}),
    updateFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    clearFilterIndex: PropTypes.func,
    fetchOptionLeadType: PropTypes.func,
    fetchOptionLanguageIndicator: PropTypes.func,
    dataIsLoading: PropTypes.bool,
    updateProgressBarValue: PropTypes.func,
    odataNextLink: PropTypes.string,
    campodataNextLink: PropTypes.string,
    inspectionodataNextLink: PropTypes.string,
    updateProgressBarMaxCount: PropTypes.func,
    fetchAgentList: PropTypes.func,
    fetchAgentListPrimary: PropTypes.func,
    confirmAssignment: PropTypes.func,
    applyAssignment: PropTypes.func,
    impersonation: PropTypes.bool,
    callLoadingScreen: PropTypes.func,
    fetchCampaignData: PropTypes.func,
    fetchInspectionsData: PropTypes.func,
    fetchSystemSettings: PropTypes.func,
    showAssignmentLoader: PropTypes.bool,
    updateOwnerid: PropTypes.func,
    agentData: PropTypes.shape({
      list: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    agentPrimaryData: PropTypes.shape({
      list: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    resetProgressBar: PropTypes.func,
    ownerId: PropTypes.string,
    newOwnerId: PropTypes.arrayOf(PropTypes.string),
    fetchOptionDisposition: PropTypes.func,
    applySearchName: PropTypes.func,
    applySearchStreet: PropTypes.func,
    applySearchWritingAgent: PropTypes.func,
    priAndSecRecordMapping: PropTypes.shape({}),
    progressBar: PropTypes.shape({}),
    searchValueNameTabOne: PropTypes.string,
    searchStreetAddressTabOne: PropTypes.string,
    searchValueNameTabTwo: PropTypes.string,
    searchStreetAddressTabTwo: PropTypes.string,
    searchWritingAgentTabThree: PropTypes.string,
    searchValueNameTabThree: PropTypes.string,
    updateNameSearchParameter: PropTypes.func,
    updateStreetSearchParameter: PropTypes.func,
    updateWritingAgentParameter: PropTypes.func,
    inspectedStartIndex: PropTypes.number,
    inspectedEndIndex: PropTypes.number,
    strings: React.PropTypes.shape({}),
    loginUserRecord: PropTypes.shape({}),
    updateActivePage: PropTypes.func,
    activePage: PropTypes.bool,
    fetchCallType: PropTypes.func,
    moreRecords: PropTypes.bool,
    pageNumber: PropTypes.number,
    lastModifiedOn: PropTypes.string
  }

  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent;
    let owner1Id = '';
    let owner2Id = '';
    if (this.props.newOwnerId && this.props.newOwnerId.length > 0) {
      owner1Id = this.props.newOwnerId[0];
      owner2Id = this.props.newOwnerId[1];
    }

    let count = 0;
    debug('componentDidMount impersonation', this.props.impersonation);
    return this.props.fetchOptionLeadType()
      .then(() => {
        if (this.props.newOwnerId && this.props.newOwnerId.length > 0) {
            this.props.fetchAgentList('systemuser', owner1Id, 'url')
            .then (() => {
              if (this.props.newOwnerId.length > 1) {
                this.props.fetchAgentList('systemuser', owner2Id, 'url');
              }
            })
        } else {
          this.props.fetchAgentList('systemuser', this.props.ownerId, 'url', this.props.impersonation)    
        }
      })
      .then(() => this.props.fetchAgentListPrimary('systemuser', this.props.ownerId, 'url'))
      .then(() => this.props.fetchInspectionsData(this.props.ownerId, this.props.impersonation))
      .then(() => this.props.fetchOptionLanguageIndicator())
      .then(() => this.props.fetchOptionDisposition())
      .then(() => this.props.fetchCallType())
      .then(() => this.props.fetchSystemSettings())
      .then(() => this.props.setProgressbarLabel('Fetching Campaign Lead Records'))
      .then(() => this.props.fetchCampaignData('cica_campaignleads', this.props.ownerId, null , this.props.impersonation))
      .then(() => this.props.fetchAll('lead-Pagination', this.props.ownerId, null , this.props.pageNumber)
      // .then(() => {
      //     if (this.props.leadsData.length !== 0) {
      //       return this.props.updateProgressBarValue(this.props.leadsData.length, 'fetch');
      //     }
      //     return null;
      //   })
      //   .catch((error) => {
      //     debug('Promise errors', error);
      //   });
      //   const getLeadsCount = modelName => (
      //     fetch(modelName, this.props.ownerId, 'url', this.props.impersonation).then((response) => {
      //       count += response.data.data.result.length;
      //       // if (response.data['@odata.nextLink'] != null) {
      //       //   return getLeadsCount(response.data['@odata.nextLink']
      //       //   .replace(`${__CONFIG__.orgURI}/api/data/v8.2/`, ''));
      //       // }
      //       if (count !== 0) {
      //         this.props.resetProgressBar('fetch');
      //         return this.props.updateProgressBarMaxCount(count, 'fetch');
      //       }
      //       return null;
      //     })
      //     .catch((error) => {
      //       debug('Promise errors2', error);
      //     })
      //   );
      //   return getLeadsCount('lead');
      );
  }

  componentWillReceiveProps(nextProps) {
    console.log('nextProps==> ', nextProps);
    console.log('this.props.moreRecords==> ', this.props.moreRecords);
    if (nextProps.moreRecords && (nextProps.moreRecords === true || nextProps.moreRecords === 'true' )) {
      console.log('nextProps.moreRecords==>', nextProps.moreRecords);
      let pageNumber = nextProps.pageNumber;
      // pageNumber = pageNumber + 1;
      this.props.fetchAll('lead-Pagination', this.props.ownerId, null, pageNumber);
      // .then(() => {
      //   if (this.props.rawLeadsData.length !== 0) {
      //     let totalLength = 0;
      //     this.props.rawLeadsData.forEach((current) => {
      //       totalLength += current.value.length;
      //     });
      //     return this.props.updateProgressBarValue(totalLength, 'fetch');
      //   }
      //   return null;
      // });
    } else if ((nextProps.moreRecords === 'false' || nextProps.moreRecords === false )&& nextProps.moreRecords !== this.props.moreRecords) {
      console.log('nextProps.moreRecords==>', nextProps.moreRecords);
      this.props.showLeads();
      this.props.showInspections();
    }
    if (nextProps.campodataNextLink !== 'null' && nextProps.campodataNextLink !== this.props.campodataNextLink) {
      this.props.fetchCampaignData(this.props.ownerId, this.props.impersonation, nextProps.campodataNextLink.replace(`${__CONFIG__.orgURI}/api/data/v8.2/`, ''));
    }
    if (nextProps.inspectionodataNextLink !== 'null' && nextProps.inspectionodataNextLink !== this.props.inspectionodataNextLink) {
      this.props.fetchInspectionsData('cica_inspections', this.props.ownerId, 'url');
    }
  }

  onBackButtonEvent = (e) => {
    e.preventDefault();
    location.reload();
  }

  getUserPosition = () => {
    let userPostion = '';
    const { strings } = this.props;
    const loginUserRecord = this.props.loginUserRecord;
    if ((loginUserRecord.cica_positioncode === '14' && (loginUserRecord.cica_salesforce === '19' ||loginUserRecord.cica_salesforce === '18')) || ((loginUserRecord.cica_positioncode === '16') && loginUserRecord.cica_salesforce === '02')) {
      userPostion = strings.lastassignedDate;
    } else if (((loginUserRecord.cica_positioncode === '10' || loginUserRecord.cica_positioncode === '06' || loginUserRecord.cica_positioncode === '13') && (loginUserRecord.cica_salesforce === '19' ||loginUserRecord.cica_salesforce === '18')) || 
      ((loginUserRecord.cica_positioncode === '33' || loginUserRecord.cica_positioncode === '60' || loginUserRecord.cica_positioncode === '70') && loginUserRecord.cica_salesforce === '02')) {
      userPostion = strings.lastassignedDateMD;
    }
    return userPostion;
  };

  getColumndata = () => {
    const { strings } = this.props;
    const tempColumnData = [
      {
        label: strings.selectall,
        dataKey: 'checkBox',
        styleName: '',
        flexGrow: 0.4
      },
      {
        label: strings.name,
        dataKey: 'name',
        styleName: '',
        flexGrow: 1.2
      },
      {
        label: strings.state,
        dataKey: 'state',
        styleName: '',
        flexGrow: 0.6
      },
      {
        label: strings.county,
        dataKey: 'county',
        styleName: '',
        flexGrow: 0.6
      },
      {
        label: strings.city,
        dataKey: 'city',
        styleName: '',
        flexGrow: 0.6
      },
      {
        label: strings.zip,
        dataKey: 'zip',
        styleName: '',
        flexGrow: 0.6
      },
      {
        label: strings.leadtype,
        dataKey: 'leadType',
        styleName: '',
        flexGrow: 0.7
      },
      {
        label: strings.streetaddress,
        dataKey: 'streetAddress',
        styleName: 'wrapContentAddress',
        flexGrow: 0.98
      },
      {
        label: strings.lastassigned,
        dataKey: 'lastAssigned',
        styleName: '',
        flexGrow: 1
      },
      {
        label: strings.sellingagent,
        dataKey: 'lastSelling',
        styleName: '',
        flexGrow: 1
      },
      {
        label: strings.assignedto,
        dataKey: 'assignedTo',
        styleName: '',
        flexGrow: 1
      },
      {
        label: strings.disposition,
        dataKey: 'disposition',
        styleName: '',
        flexGrow: 0.7
      },
      {
        label: this.getUserPosition(),
        dataKey: 'assignedDate',
        styleName: '',
        flexGrow: 0.8
      },
      {
        label: strings.dateAssigned,
        dataKey: 'dateAssignedValue',
        styleName: '',
        flexGrow: 0.8
      },
      {
        label: strings.tier,
        dataKey: 'tier',
        styleName: '',
        flexGrow: 0.5
      },
      {
        label: '',
        dataKey: 'showHouseKey',
        styleName: '',
        flexGrow: 0.4
      },
    ];

    return tempColumnData;
  }

  getInspectionsColumnData = () => {
    const { strings } = this.props;
    const tempInspectionsColumnData = [
      {
        label: strings.insuredName,
        dataKey: 'cica_customername',
        styleName: '',
        flexGrow: 0.85
      },
      {
        label: strings.calltype,
        dataKey: 'cica_calltype',
        styleName: '',
        flexGrow: 0.6
      },
      {
        label: strings.phoneNumber,
        dataKey: 'phoneNumber',
        styleName: '',
        flexGrow: 0.7
      },
      {
        label: strings.writingagent,
        dataKey: 'cica_writingagent',
        styleName: '',
        flexGrow: 0.85
      },
      {
        label: strings.division,
        dataKey: 'division',
        styleName: '',
        flexGrow: 0.5
      },
      {
        label: strings.product,
        dataKey: 'product',
        styleName: '',
        flexGrow: 0.45
      },
      {
        label: strings.appdate,
        dataKey: 'cica_appdate',
        styleName: '',
        flexGrow: 0.7
      },
      {
        label: strings.expires,
        dataKey: 'expires',
        styleName: '',
        flexGrow: 0.6
      }
    ];
    return tempInspectionsColumnData;
  }

  logout() {
    debug('logout');
    logout();
  }

  filterInspData = tabThreeList => tabThreeList && tabThreeList.filter(data =>
    data.cica_isexpired === false && data.cica_issubmitted === false);

  render() {
    let columnValue = [];
    let inspectionsColumnValue = [];
    columnValue = this.getColumndata();
    inspectionsColumnValue = this.getInspectionsColumnData();
    debug('dataIsLoading', this.props.dataIsLoading);
    return (
      <div className={styles.flexDash}>
        {
          this.props.showAssignmentLoader &&
          <div className={styles.showIndicator}>
            <ProgressBar type="circular" mode="indeterminate" multicolor />
          </div>
        }
        <FixedTabs
          columnData={columnValue}
          inspectionsColumnData={inspectionsColumnValue}
          updateSelectedRecords={this.props.updateSelectedRecords}
          selectedRecords={this.props.selectedRecords}
          tabOneList={this.props.tabOneList}
          tabTwoList={this.props.tabTwoList}
          currentLanguage={this.props.currentLanguage}
          tabThreeList={this.filterInspData(this.props.tabThreeList)}
          leadsData={this.props.leadsData}
          updateUnassignedStartEndIndex={this.props.updateUnassignedStartEndIndex}
          unassignedStartIndex={this.props.unassignedStartIndex}
          unassignedEndIndex={this.props.unassignedEndIndex}
          updateAssignedStartEndIndex={this.props.updateAssignedStartEndIndex}
          assignedStartIndex={this.props.assignedStartIndex}
          assignedEndIndex={this.props.assignedEndIndex}
          activeIndex={this.props.activeIndex}
          updateActiveIndex={this.props.updateActiveIndex}
          updateFilterExpanded={this.props.updateFilterExpanded}
          filterExpanded={this.props.filterExpanded}
          inspectionFilterData={util.inspectionFilterCRMFieldMap(null, this.props.strings)}
          filterData={util.filterDataCRMFieldMapper(null, this.props.strings)}
          updateFilter={this.props.updateFilter}
          filterValues={this.props.filterValues}
          applyFilter={this.props.applyFilter}
          applyFilterIndex={this.props.applyFilterIndex}
          clearFilter={this.props.clearFilter}
          clearFilterIndex={this.props.clearFilterIndex}
          dataIsLoading={this.props.dataIsLoading}
          applySearchName={this.props.applySearchName}
          applySearchStreet={this.props.applySearchStreet}
          applySearchWritingAgent={this.props.applySearchWritingAgent}
          tabOneSearchList={this.props.tabOneSearchList}
          tabTwoSearchList={this.props.tabTwoSearchList}
          tabThreeSearchList={this.props.tabThreeSearchList}
          priAndSecRecordMapping={this.props.priAndSecRecordMapping}
          searchValueNameTabOne={this.props.searchValueNameTabOne}
          searchStreetAddressTabOne={this.props.searchStreetAddressTabOne}
          searchValueNameTabTwo={this.props.searchValueNameTabTwo}
          searchStreetAddressTabTwo={this.props.searchStreetAddressTabTwo}
          searchWritingAgentTabThree={this.props.searchWritingAgentTabThree}
          updateNameSearchParameter={this.props.updateNameSearchParameter}
          updateStreetSearchParameter={this.props.updateStreetSearchParameter}
          updateWritingAgentParameter={this.props.updateWritingAgentParameter}
          searchValueNameTabThree={this.props.searchValueNameTabThree}
          progressBar={this.props.progressBar}
          updateInspectionFilterExpanded={this.props.updateInspectionFilterExpanded}
          inspectionFilterExpanded={this.props.inspectionFilterExpanded}
          inspectedEndIndex={this.props.inspectedEndIndex}
          inspectedStartIndex={this.props.inspectedStartIndex}
          updateInspectedStartEndIndex={this.props.updateInspectedStartEndIndex}
          strings={this.props.strings}
          ownerId={this.props.ownerId}
          updateProgressBarValue={this.props.updateProgressBarValue}
          agentList={this.props.agentData.list}
          loginUserRecord={this.props.loginUserRecord}
          activePage={this.props.activePage}
          updateActivePage={this.props.updateActivePage}
        />
        {!this.props.filterExpanded &&
          (this.props.activeIndex !== 2) &&
          <Footer
            activeIndex={this.props.activeIndex}
            agentList={this.props.agentData.list}
            agentPrimaryList={this.props.agentPrimaryData.list}
            selectedRecords={this.props.selectedRecords}
            confirmAssignment={this.props.confirmAssignment}
            applyFilter={this.props.applyFilter}
            reverseFilter={this.props.reverseFilter}
            applyAssignment={this.props.applyAssignment}
            updateOwnerid={this.props.updateOwnerid}
            ownerId={this.props.ownerId}
            updateProgressBarMaxCount={this.props.updateProgressBarMaxCount}
            updateProgressBarValue={this.props.updateProgressBarValue}
            resetProgressBar={this.props.resetProgressBar}
            updateSelectedRecords={this.props.updateSelectedRecords}
            callLoadingScreen={this.props.callLoadingScreen}
            updateFilter={this.props.updateFilter}
            tabOneList={this.props.tabOneList}
            tabTwoList={this.props.tabTwoList}
            filterValues={this.props.filterValues}
            loginUserRecord={this.props.loginUserRecord}
            currentLanguage={this.props.currentLanguage}
            strings={this.props.strings}
          />
        }
      </div>
    );
  }
}

Assign.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  tabOneList: state.assign.tabOneLeadsData,
  tabTwoList: state.assign.tabTwoLeadsData,
  tabThreeList: state.assign.tabThreeInsData,
  tabOneSearchList: state.assign.tabOneSearchData,
  tabTwoSearchList: state.assign.tabTwoSearchData,
  tabThreeSearchList: state.assign.tabThreeSearchData,
  insSearchNameFiltered: state.assign.insSearchNameFiltered,
  leadsData: state.assign.leadsData,
  rawLeadsData: state.assign.rawLeadsData,
  newOwnerId: state.assign.newOwnerId,
  showAssignmentLoader: state.assign.showAssignmentLoader,
  error: state.assign.error,
  unassignedStartIndex: state.assign.unassigned.startIndex,
  unassignedEndIndex: state.assign.unassigned.endIndex,
  assignedStartIndex: state.assign.assigned.startIndex,
  assignedEndIndex: state.assign.assigned.endIndex,
  activeIndex: state.assign.activeIndex,
  selectedRecords: state.assign.selectedRecords,
  filterExpanded: state.assign.filterExpanded,
  inspectionFilterExpanded: state.assign.inspectionFilterExpanded,
  filterValues: state.assign && state.assign.filter,
  odataNextLink: state.assign.odataNextLink,
  campodataNextLink: state.assign.campodataNextLink,
  dataIsLoading: state.assign && state.assign.isLoading,
  agentData: state.assign.agentData,
  agentPrimaryData: state.assign.agentPrimaryData,
  ownerId: state.assign.ownerId,
  impersonation: state.assign.impersonation,
  priAndSecRecordMapping: state.assign.primaryAndSecondaryRecordMapping,
  searchValueNameTabOne: state.assign.searchValueNameTabOne,
  searchStreetAddressTabOne: state.assign.searchStreetAddressTabOne,
  searchValueNameTabTwo: state.assign.searchValueNameTabTwo,
  searchStreetAddressTabTwo: state.assign.searchStreetAddressTabTwo,
  searchWritingAgentTabThree: state.assign.searchWritingAgentTabThree,
  searchValueNameTabThree: state.assign.searchValueNameTabThree,
  progressBar: !__MANAGE__ && state.app.progressBar,
  inspectedEndIndex: state.assign.inspected.endIndex,
  inspectedStartIndex: state.assign.inspected.startIndex,
  currentLanguage: state.assign && state.assign.currentLanguage,
  activePage: state.assign && state.assign.activePage,
  pageNumber: state.assign && state.assign.pageNumber,
  moreRecords: state.assign && state.assign.moreRecords,
  lastModifiedOn: state.assign && state.assign.lastModifiedOn
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign(
      {},
      actions,
      assigncreator
    ), dispatch
  );
}

const AssignString = translate('Assign')(Assign);
/*
Following Actions are being mapped to props
  1) fetchAll
  2) updateUnassignedStartEndIndex
  3) updateAssignedStartEndIndex
  4) updateSelectedRecords
  5) updateFilterExpanded
  6) updateFilter
  7) applyFilter
  8) clearFilter
  9) fetchOptionLeadType
  10)fetchOptionLanguageIndicator
  11) fetchAgentList
  12) fetchOwnerId
  13) updateProgressBarValue
  14) updateProgressBarMaxCount
  15) resetProgressBar
  16) fetchOptionDisposition
  17) reverseFilter
  18) updateNameSearchParameter
  19) updateStreetSearchParameter
  20) updateWritingAgentParameter
*/

export default connect(mapStateToProps, mapDispatchToProps)(AssignString);



// WEBPACK FOOTER //
// ./src/containers/Assign/Assign.js